import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../../providers/withRouter";
import { Link } from "react-router-dom";
import { alpha, styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import {
  subirDocumentacionProveedor,
} from "../../../providers/documentos";
import InfoTooltip from "../../../components/InfoTooltip";
import CircularProgress from "@mui/material/CircularProgress";
import {  getCommercial, getOneAAFF } from "../../../services";
import {
  daysDiff,
  eliminaDuplicados,
  formatoFechasEs,
  verDocumentacion,
  validarDocumentacion,
} from "../../../functions/funciones";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { TiArrowBack } from "react-icons/ti";
import { UsuarioContext } from "../../../providers/userContext";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase": {
    color: "#FF5252",
    "&:hover": {
      backgroundColor: alpha("#FF5252", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase + .MuiSwitch-track": {
    backgroundColor: "#FF5252",
  },
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#7bc977",
    backgroundColor: alpha("#7bc977", theme.palette.action.hoverOpacity),
    "&:hover": {
      backgroundColor: alpha("#7bc977", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#7bc977",
  },
}));

const CustomPendienteSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase": {
    color: "#FFD700",
  },
  "& .MuiSwitch-switchBase + .MuiSwitch-track": {
    backgroundColor: "#FFD700",
  },
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#FFD700",
    backgroundColor: alpha("#FFD700", theme.palette.action.hoverOpacity),
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#FFD700",
  },
}));

const Proveedores = (props) => {
  const { t } = useTranslation(['suppliers', 'common', 'aaff']);
  const user = useContext(UsuarioContext)
  const [proveedores, setProveedores] = useState([]);
  const [aaff, setAaff] = useState({});
  const [comercial, setComercial] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [recargar, setRecargar] = useState(true);

  useEffect(() => {
    let data = {
      nif: props.params.nifAAFF,
    };
    getOneAAFF(props.params.nifAAFF).then((a) => {
      setAaff(a);
      getCommercial(a.commercial.id).then((res) => {
        setComercial(res);
      });
      let proveedores = [];
      a.properties.map((p) => {
        p.suppliers.map((s) => {
          proveedores.push(s);
        });
      });
      setProveedores(eliminaDuplicados(proveedores));
      setIsLoading(false);
    });
  }, [recargar]);

  const handleSubirDocsCallback = () => {
    setRecargar(!recargar);
  };

  const comprobarArchivos = async (validado, status, ruta, id, idDoc, rol, nif, noProcede = false) => {
    if(validado && status){
     verDocumentacion(ruta, id, idDoc, rol, nif, noProcede).then((resultado) => {
       handleSubirDocsCallback(resultado)
     })
    }else{
      subirDocumentacionProveedor(ruta, id, idDoc, rol, nif, noProcede).then((resultado) => {
        handleSubirDocsCallback(resultado)
      })
    }
  };

  return (
    <>
      <BreadCrumb rutas={[{path:'/comerciales', label: t('common:commercials.title')}, {path:`/comerciales`, label:`${comercial.nombre+" "+comercial.apellidos}`}, {path:`/aaff/${aaff.nif}/comunidades`, label:`${aaff.razonSocial}`}, {path:'/proveedores', label: t('title')}]} style={{ margin: '0 10px'}} />
      <div className="listPage">
        <div className="gridCard">
          <div className="gridHead">
            {t('listHeader')}
            <Link to={`/comerciales/${props.params.nifComercial}/aaff`}>
              <div className="gridHeadRight">
                <TiArrowBack style={{ fontSize: 23}} />
              </div>
            </Link>
          </div>
          <div className="tableContainer">
            <div className="tableWrapper">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>{t('columns.supplier')}</th>
                    <th>{t('common:form.nif')}</th>
                    <th>{t('columns.lastReclamation')}</th>
                    <th style={{ textAlign: "center" }}>
                      <InfoTooltip title={t('documentTypes.rcFull')}>{t('documentTypes.rc')}</InfoTooltip>
                    </th>
                    <th style={{ textAlign: "center" }}>{t('documentTypes.preventiveModality')}</th>
                    <th style={{ textAlign: "center" }}>{t('documentTypes.riskAssessment')}</th>
                    <th style={{ textAlign: "center" }}>{t('documentTypes.preventivePlanning')}</th>
                    <th style={{ textAlign: "center" }}>{t('documentTypes.workersList')}</th>
                    <th style={{ textAlign: "center" }}>
                      <InfoTooltip title={t('documentTypes.rlcFull')}>{t('documentTypes.rlc')}</InfoTooltip>
                    </th>
                    <th style={{ textAlign: "center" }}>
                      <InfoTooltip title={t('documentTypes.rntFull')}>{t('documentTypes.rnt')}</InfoTooltip>
                    </th>
                    <th style={{ textAlign: "center" }}>{t('documentTypes.socialSecurityCert')}</th>
                    <th style={{ textAlign: "center" }}>{t('documentTypes.responsibleDeclaration')}</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan="12" style={{ textAlign: "center" }}>
                        <CircularProgress style={{ color: "#92004D" }} />{" "}
                      </td>
                    </tr>
                  ) : proveedores.length === 0 ? (
                    <tr>
                      <td colSpan="12" style={{ textAlign: "center" }}>
                        {t('noHaveSuppliers')}
                      </td>
                    </tr>
                  ) : (
                    proveedores.map((e, i) => {
                      const color =
                        daysDiff(new Date(e.ultimaReclamacion), new Date()) > 30
                          ? "red"
                          : "#303248";
                      return (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>
                            <Link to={"/proveedores/" + e.nif}>
                              {e.razonSocial}
                            </Link>
                          </td>
                          <td>{e.nif}</td>
                          <td>
                            {e.ultimaReclamacion === undefined ||
                            e.ultimaReclamacion === null ? (
                              <span
                                style={{
                                  color:
                                    daysDiff(
                                      new Date(e.createdAt),
                                      new Date()
                                    ) > 30
                                      ? "red"
                                      : "#303248",
                                }}
                              >
                                {formatoFechasEs(e.createdAt)}
                              </span>
                            ) : (
                              <span
                                style={{
                                  color:
                                    daysDiff(
                                      new Date(e.ultimaReclamacion),
                                      new Date()
                                    ) > 30
                                      ? "red"
                                      : "#303248",
                                }}
                              >
                                {formatoFechasEs(e.ultimaReclamacion)}
                              </span>
                            )}
                          </td>
                          {/*RC*/}
                          <td style={{ textAlign: "center" }}>
                            {e?.docssupps?.find( d => d.tipoDoc === 2 )?.pendiente ? (
                              <CustomPendienteSwitch
                                checked={false}
                                onClick={() => validarDocumentacion(e?.docssupps?.find( d => d.tipoDoc === 2 )?.ruta, e?.docssupps?.find( d => d.tipoDoc === 2 )?.id, 2, e.nif)}
                              />
                            ) : (
                              <CustomSwitch
                                checked={e?.docssupps?.find( d => d.tipoDoc === 2 )?.validado}
                                onClick={
                                  () => comprobarArchivos(
                                    e?.docssupps?.find( d => d.tipoDoc === 2 )?.validado,
                                    e?.docssupps?.find( d => d.tipoDoc === 2 )?.status,
                                    e?.docssupps?.find( d => d.tipoDoc === 2 )?.ruta,
                                    e?.docssupps?.find( d => d.tipoDoc === 2 )?.id, 
                                    2, 
                                    user.rol, 
                                    e.nif
                                  )
                                }
                              />
                            )}
                            <small style={{ display: "block" }}>
                            {e?.docssupps?.find( d => d.tipoDoc === 2 )?.fechaCaducidad !==
                              null && e?.docssupps?.find( d => d.tipoDoc === 2 )?.status ? (
                                <span
                                  style={{
                                    color:
                                      daysDiff(
                                        new Date(
                                          e?.docssupps?.find( d => d.tipoDoc === 2 )?.fechaCaducidad
                                        ),
                                        new Date()
                                      ) > 30
                                        ? "red"
                                        : "black",
                                  }}
                                >
                                  {new Date(
                                    e?.docssupps?.find( d => d.tipoDoc === 2 )?.fechaCaducidad
                                  ).toLocaleDateString()}
                                </span>
                              ) : (
                                "-"
                              )}
                            </small>
                          </td>
                          {/*Modalidad Preventiva*/}
                          <td style={{ textAlign: "center" }}>
                            
                            {e?.docssupps?.find( d => d.tipoDoc === 3 )?.pendiente ? (
                              <CustomPendienteSwitch
                                checked={false}
                                onClick={() => validarDocumentacion(e?.docssupps?.find( d => d.tipoDoc === 3 )?.ruta, e?.docssupps?.find( d => d.tipoDoc === 3 )?.id, 3, e.nif)}
                              />
                            ) : (
                              
                              <CustomSwitch
                                checked={e?.docssupps?.find( d => d.tipoDoc === 3 )?.validado}
                                onClick={
                                  () => comprobarArchivos(
                                    e?.docssupps?.find( d => d.tipoDoc === 3 )?.validado,
                                    e?.docssupps?.find( d => d.tipoDoc === 3 )?.status,
                                    e?.docssupps?.find( d => d.tipoDoc === 3 )?.ruta,
                                    e?.docssupps?.find( d => d.tipoDoc === 3 )?.id, 
                                    3, 
                                    user.rol, 
                                    e.nif
                                  )
                                }
                              />
                            )}
                            <small style={{ display: "block" }}>
                              {e?.docssupps?.find( d => d.tipoDoc === 3 )?.fechaCaducidad !==
                              null && e?.docssupps?.find( d => d.tipoDoc === 3 )?.status ? (
                                <span
                                  style={{
                                    color:
                                      daysDiff(
                                        new Date(
                                          e?.docssupps?.find( d => d.tipoDoc === 3 )?.fechaCaducidad
                                        ),
                                        new Date()
                                      ) > 30
                                        ? "red"
                                        : "black",
                                  }}
                                >
                                  {new Date(
                                    e?.docssupps?.find( d => d.tipoDoc === 3 )?.fechaCaducidad
                                  ).toLocaleDateString()}
                                </span>
                              ) : (
                                "-"
                              )}
                            </small>
                          </td>
                          {/*Evaluacion Riesgos*/}
                          <td style={{ textAlign: "center" }}>
                            {e?.docssupps?.find( d => d.tipoDoc === 5 )?.pendiente ? (
                              <CustomPendienteSwitch
                                checked={false}
                                onClick={() => validarDocumentacion(e?.docssupps?.find( d => d.tipoDoc === 5 )?.ruta, e?.docssupps?.find( d => d.tipoDoc === 5 )?.id, 5, e.nif)}
                              />
                            ) : (
                              <CustomSwitch
                                checked={e?.docssupps?.find( d => d.tipoDoc === 5 )?.validado}
                                onClick={
                                  () => comprobarArchivos(
                                    e?.docssupps?.find( d => d.tipoDoc === 5 )?.validado,
                                    e?.docssupps?.find( d => d.tipoDoc === 5 )?.status,
                                    e?.docssupps?.find( d => d.tipoDoc === 5 )?.ruta,
                                    e?.docssupps?.find( d => d.tipoDoc === 5 )?.id, 
                                    5, 
                                    user.rol, 
                                    e.nif
                                  )
                                }
                              />
                            )}
                            <small style={{ display: "block" }}>-</small>
                          </td>
                          {/*Planificacion Preventiva*/}
                          <td style={{ textAlign: "center" }}>
                            {e?.docssupps?.find( d => d.tipoDoc === 4 )?.pendiente ? (
                              <CustomPendienteSwitch
                                checked={false}
                                onClick={() => validarDocumentacion(e?.docssupps?.find( d => d.tipoDoc === 4 )?.ruta, e?.docssupps?.find( d => d.tipoDoc === 4 )?.id, 4, e.nif)}
                              />
                            ) : (
                              <CustomSwitch
                                checked={e?.docssupps?.find( d => d.tipoDoc === 4 )?.validado}
                                onClick={
                                  () => comprobarArchivos(
                                    e?.docssupps?.find( d => d.tipoDoc === 4 )?.validado,
                                    e?.docssupps?.find( d => d.tipoDoc === 4 )?.status,
                                    e?.docssupps?.find( d => d.tipoDoc === 4 )?.ruta,
                                    e?.docssupps?.find( d => d.tipoDoc === 4 )?.id, 
                                    4, 
                                    user.rol, 
                                    e.nif
                                  )
                                }
                              />
                            )}
                            <small style={{ display: "block" }}>
                              {e?.docssupps?.find( d => d.tipoDoc === 4 )?.fechaCaducidad !==
                              null && e?.docssupps?.find( d => d.tipoDoc === 4 )?.status ? (
                                <span
                                  style={{
                                    color:
                                      daysDiff(
                                        new Date(
                                          e?.docssupps?.find( d => d.tipoDoc === 4 )?.fechaCaducidad
                                        ),
                                        new Date()
                                      ) > 30
                                        ? "red"
                                        : "black",
                                  }}
                                >
                                  {new Date(
                                    e?.docssupps?.find( d => d.tipoDoc === 4 )?.fechaCaducidad
                                  ).toLocaleDateString()}
                                </span>
                              ) : (
                                "-"
                              )}
                            </small>
                          </td>
                          {/*Listado Trabajadores*/}
                          <td style={{ textAlign: "center" }}>
                            {e?.docssupps?.find( d => d.tipoDoc === 10 )?.pendiente ? (
                              <CustomPendienteSwitch
                                checked={false}
                                onClick={() => validarDocumentacion(e?.docssupps?.find( d => d.tipoDoc === 10 )?.ruta, e?.docssupps?.find( d => d.tipoDoc === 10 )?.id, 10, e.nif)}
                              />
                            ) : (
                              <CustomSwitch
                                checked={e?.docssupps?.find( d => d.tipoDoc === 10 )?.validado}
                                onClick={
                                  () => comprobarArchivos(
                                    e?.docssupps?.find( d => d.tipoDoc === 10 )?.validado,
                                    e?.docssupps?.find( d => d.tipoDoc === 10 )?.status,
                                    e?.docssupps?.find( d => d.tipoDoc === 10 )?.ruta,
                                    e?.docssupps?.find( d => d.tipoDoc === 10 )?.id, 
                                    10, 
                                    user.rol, 
                                    e.nif
                                  )
                                }
                              />
                            )}
                            <small style={{ display: "block" }}>
                            {e?.docssupps?.find( d => d.tipoDoc === 10 )?.fechaCaducidad !==
                              null && e?.docssupps?.find( d => d.tipoDoc === 10 )?.status ? (
                                <span
                                  style={{
                                    color:
                                      daysDiff(
                                        new Date(
                                          e?.docssupps?.find( d => d.tipoDoc === 10 )?.fechaCaducidad
                                        ),
                                        new Date()
                                      ) > 30
                                        ? "red"
                                        : "black",
                                  }}
                                >
                                  {new Date(
                                    e?.docssupps?.find( d => d.tipoDoc === 10 )?.fechaCaducidad
                                  ).toLocaleDateString()}
                                </span>
                              ) : (
                                "-"
                              )}
                            </small>
                          </td>
                          {/*RLC*/}
                          <td style={{ textAlign: "center" }}>
                            {e?.docssupps?.find( d => d.tipoDoc === 9 )?.pendiente ? (
                              <CustomPendienteSwitch
                                checked={false}
                                onClick={() => validarDocumentacion(e?.docssupps?.find( d => d.tipoDoc === 9 )?.ruta, e?.docssupps?.find( d => d.tipoDoc === 9 )?.id, 9, e.nif)}
                              />
                            ) : (
                              <CustomSwitch
                                checked={e?.docssupps?.find( d => d.tipoDoc === 9 )?.validado}
                                onClick={
                                  () => comprobarArchivos(
                                    e?.docssupps?.find( d => d.tipoDoc === 9 )?.validado,
                                    e?.docssupps?.find( d => d.tipoDoc === 9 )?.status,
                                    e?.docssupps?.find( d => d.tipoDoc === 9 )?.ruta,
                                    e?.docssupps?.find( d => d.tipoDoc === 9 )?.id,
                                    9,
                                    user.rol,
                                    e.nif,
                                    e?.noProcede
                                  )
                                }
                              />
                            )}
                            <small style={{ display: "block" }}>
                            {e?.docssupps?.find( d => d.tipoDoc === 9 )?.fechaCaducidad !==
                              null && e?.docssupps?.find( d => d.tipoDoc === 9 )?.status ? (
                                <span
                                  style={{
                                    color:
                                      daysDiff(
                                        new Date(
                                          e?.docssupps?.find( d => d.tipoDoc === 9 )?.fechaCaducidad
                                        ),
                                        new Date()
                                      ) > 30
                                        ? "red"
                                        : "black",
                                  }}
                                >
                                  {new Date(
                                    e?.docssupps?.find( d => d.tipoDoc === 9 )?.fechaCaducidad
                                  ).toLocaleDateString()}
                                </span>
                              ) : (
                                "-"
                              )}
                            </small>
                          </td>
                          {/*RNT*/}
                          <td style={{ textAlign: "center" }}>
                            {e?.docssupps?.find( d => d.tipoDoc === 8 )?.pendiente ? (
                              <CustomPendienteSwitch
                                checked={false}
                                onClick={() => validarDocumentacion(e?.docssupps?.find( d => d.tipoDoc === 8 )?.ruta, e?.docssupps?.find( d => d.tipoDoc === 8 )?.id, 8, e.nif)}
                              />
                            ) : (
                              <CustomSwitch
                                checked={e?.docssupps?.find( d => d.tipoDoc === 8 )?.validado}
                                onClick={
                                  () => comprobarArchivos(
                                    e?.docssupps?.find( d => d.tipoDoc === 8 )?.validado,
                                    e?.docssupps?.find( d => d.tipoDoc === 8 )?.status,
                                    e?.docssupps?.find( d => d.tipoDoc === 8 )?.ruta,
                                    e?.docssupps?.find( d => d.tipoDoc === 8 )?.id,
                                    8,
                                    user.rol,
                                    e.nif,
                                    e?.noProcede
                                  )
                                }
                              />
                            )}
                            <small style={{ display: "block" }}>
                            {e?.docssupps?.find( d => d.tipoDoc === 8 )?.fechaCaducidad !==
                              null && e?.docssupps?.find( d => d.tipoDoc === 8 )?.status ? (
                                <span
                                  style={{
                                    color:
                                      daysDiff(
                                        new Date(
                                          e?.docssupps?.find( d => d.tipoDoc === 8 )?.fechaCaducidad
                                        ),
                                        new Date()
                                      ) > 30
                                        ? "red"
                                        : "black",
                                  }}
                                >
                                  {new Date(
                                    e?.docssupps?.find( d => d.tipoDoc === 8 )?.fechaCaducidad
                                  ).toLocaleDateString()}
                                </span>
                              ) : (
                                "-"
                              )}
                            </small>
                          </td>
                          {/*Justificante seg. social*/}
                          <td style={{ textAlign: "center" }}>
                            {e?.docssupps?.find( d => d.tipoDoc === 6 )?.pendiente ? (
                              <CustomPendienteSwitch
                                checked={false}
                                onClick={() => validarDocumentacion(e?.docssupps?.find( d => d.tipoDoc === 6 )?.ruta, e?.docssupps?.find( d => d.tipoDoc === 6 )?.id, 6, e.nif)}
                              />
                            ) : (
                              <CustomSwitch
                                checked={e?.docssupps?.find( d => d.tipoDoc === 6 )?.validado}
                                onClick={
                                  () => comprobarArchivos(
                                    e?.docssupps?.find( d => d.tipoDoc === 6 )?.validado,
                                    e?.docssupps?.find( d => d.tipoDoc === 6 )?.status,
                                    e?.docssupps?.find( d => d.tipoDoc === 6 )?.ruta,
                                    e?.docssupps?.find( d => d.tipoDoc === 6 )?.id, 
                                    6, 
                                    user.rol, 
                                    e.nif
                                  )
                                }
                              />
                            )}
                            <small style={{ display: "block" }}>
                              {e?.docssupps?.find( d => d.tipoDoc === 6 )?.fechaCaducidad !==
                                null && e?.docssupps?.find( d => d.tipoDoc === 6 )?.status ? (
                                  <span
                                    style={{
                                      color:
                                        daysDiff(
                                          new Date(
                                            e?.docssupps?.find( d => d.tipoDoc === 6 )?.fechaCaducidad
                                          ),
                                          new Date()
                                        ) > 30
                                          ? "red"
                                          : "black",
                                    }}
                                  >
                                    {new Date(
                                      e?.docssupps?.find( d => d.tipoDoc === 6 )?.fechaCaducidad
                                    ).toLocaleDateString()}
                                  </span>
                                ) : (
                                  "-"
                                )}
                            </small>
                          </td>
                          {/*Declaracion Responsable*/}
                          <td style={{ textAlign: "center" }}>
                            {e?.declres?.find( d => d.aaff_id === aaff.id )?.pendiente ? (
                              <CustomPendienteSwitch
                                checked={false}
                                onClick={() => validarDocumentacion(e?.declres?.find( d => d.aaff_id === aaff.id )?.ruta, e?.declres?.find( d => d.aaff_id === aaff.id )?.id, e.nif)}
                              />
                            ) : (
                              <CustomSwitch
                                checked={e?.declres?.find( d => d.aaff_id === aaff.id )?.validado}
                                onClick={
                                  () => comprobarArchivos(
                                    e.nif,
                                    aaff.id,
                                    e?.declres?.find( d => d.aaff_id === aaff.id )?.ruta,
                                    e?.declres?.find( d => d.aaff_id === aaff.id )?.id, 
                                  )
                                }
                              />
                            )}
                            <small style={{ display: "block" }}>-</small>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
            <input type="file" id="fileElem" hidden></input>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(Proveedores);